import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const HomeRedirect = () => {
  const { isAdmin } = useAuth();
  return <Navigate to={isAdmin ? "/admin" : "/events"} replace />;
};

export default HomeRedirect;
